import {
  ButtonProps,
  Stack,
  Typography,
  TypographyProps,
} from "@mui/material";
import HelpButton from "../../Buttons/HelpButton/HelpButton";
import { useMemo } from "react";

export interface HelperOutputProps extends TypographyProps {
  helpButtonText?: string;
  showEndAdornmentOnChildrenNull?: boolean;
  label: string | React.ReactNode;
  endAdornment: string | React.ReactNode;
  buttonVariant?: ButtonProps["variant"];
}

export const HelpOutput = (props: HelperOutputProps) => {
  // TODO: Refactor stackSX according to the MUI design
  const {
    label,
    id,
    helpButtonText,
    variant = "h6",
    endAdornment,
    children,
    buttonVariant,
    showEndAdornmentOnChildrenNull = false,
    sx = {
      fontSize: "clamp(0.875rem, 4vw, 1rem)",
      fontWeight: 300,
    },
    ...others
  } = props;

  const endAdornmentToShow = useMemo(() => {
    if (showEndAdornmentOnChildrenNull) {
      return children ? endAdornment : null;
    }
    return endAdornment;
  }, [showEndAdornmentOnChildrenNull, children, endAdornment]);

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      direction="row"
      flexWrap="wrap"
      sx={{ gap: 1, my: 1 }}
    >
      {label && <Typography variant="h6">{label}</Typography>}
      <Stack
        direction="row"
        alignItems="center"
        gap={3}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Typography variant={variant} sx={sx} {...others}>
          {children}
        </Typography>
        <Typography variant={variant} sx={sx} {...others}>
          {endAdornmentToShow}
        </Typography>
      </Stack>
      {helpButtonText && (
        <HelpButton
          id={id ? id + "-helpButton" : null}
          text={helpButtonText}
          variant={buttonVariant}
        />
      )}
    </Stack>
  );
};
